export default __webpack_public_path__ + "static/media/notification-group-msg.7c75a3a0.mp3";